/* ica-homepage.js
   Vanilla JS for the ICA homepage. No jQuery, no framework.
   Loaded with `defer` so it runs after DOM parse but before window.load.
*/
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // ------------------------------------------------------------
    // Mobile drawer toggle
    // ------------------------------------------------------------
    var ham = document.getElementById('ica-hamburger-btn');
    var hamClose = document.getElementById('ica-hamburger-close');
    var drawer = document.getElementById('ica-mobile-drawer');

    function openDrawer() {
      if (!drawer || !ham) return;
      drawer.classList.add('is-open');
      ham.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer || !ham) return;
      drawer.classList.remove('is-open');
      ham.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (ham) ham.addEventListener('click', openDrawer);
    if (hamClose) hamClose.addEventListener('click', closeDrawer);
    if (drawer) {
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', closeDrawer);
      });
    }

    // ------------------------------------------------------------
    // Footer accordion (mobile only — CSS handles desktop)
    // ------------------------------------------------------------
    document.querySelectorAll('.ica-footer-nav-col h3').forEach(function (h) {
      h.addEventListener('click', function () {
        if (window.matchMedia('(min-width: 768px)').matches) return;
        var col = h.parentElement;
        col.setAttribute('data-open', col.getAttribute('data-open') === 'true' ? 'false' : 'true');
      });
    });

    // ------------------------------------------------------------
    // Catalog direct download (B4 — email gate dropped, mirrors B1 TDS).
    // The anchor downloads the PDF natively; we just fire `catalog_downloaded`
    // on click so the BRDG event still records the download (no email now).
    // ------------------------------------------------------------
    var catalogBtn = document.querySelector('.ica-catalog__download-btn');
    if (catalogBtn) {
      catalogBtn.addEventListener('click', function () {
        if (window.icaEvents && typeof window.icaEvents.fire === 'function') {
          window.icaEvents.fire('catalog_downloaded', {
            source_page: 'homepage',
            catalog_file_url: catalogBtn.getAttribute('href') || ''
          });
        }
      });
    }

    // ------------------------------------------------------------
    // Newsletter form
    // Fires `newsletter_subscribed` event (10th event type).
    // ------------------------------------------------------------
    var newsForm = document.getElementById('ica-newsletter-form');
    if (newsForm) {
      newsForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailEl = document.getElementById('ica-newsletter-email');
        if (!emailEl) return;
        var email = emailEl.value.trim();
        if (!email || email.indexOf('@') < 1) {
          emailEl.focus();
          return;
        }
        if (window.icaEvents && typeof window.icaEvents.fire === 'function') {
          window.icaEvents.fire('newsletter_subscribed', {
            source_page: 'homepage_footer',
            email: email
          });
        }
        newsForm.outerHTML =
          '<div class="ica-footer-success" role="status">' +
          '<strong>Subscribed.</strong> Next digest ships in the coming quarter. Unsubscribe any time.' +
          '</div>';
      });
    }
  });
})();
